import { AlpineComponent } from 'alpinejs';

interface SearchModalAlpineData extends AlpineComponent<Record<string, any>> {
    [key: string]: any;
    init(): void;
    opensearch(): void;
    closesearch(): void;
    _handleEscapeKey(e: KeyboardEvent): void;
}

export default (): SearchModalAlpineData => ({
    init() {
        if (!this.$refs.globalSearchInput) return;
        /**
         * on ne déclenche le watch que pour l'element modal,
         * car s'il y a plusieurs x-data="searchModal" il peut etre
         * trigger plus d'une fois
         */
        this.$watch('$store.global.searchIsOpen', (searchIsOpen: boolean) => {
            if (searchIsOpen) {
                this.$nextTick(() => {
                    this.$refs.globalSearchInput.focus();
                });
            }
        });
    },
    opensearch(): void {
        this.$store.global.searchIsOpen = true;
        document.addEventListener('keyup', this._handleEscapeKey.bind(this));
    },
    closesearch(): void {
        this.$store.global.searchIsOpen = false;
        document.removeEventListener('keyup', this._handleEscapeKey.bind(this));
    },
    _handleEscapeKey(e: KeyboardEvent): void {
        if (e.key == 'Escape') {
            this.closesearch();
        }
    },
});
